module.exports = __webpack_public_path__ + "img/delivery.ac3f13b0.jpg";